export function DeviceRow({ device, rank, themeColor, onView }) {
  // Device image selection logic
  let imageSrc;

  const name = device.device_name?.toString().toUpperCase() || "";
  const type = device.device_type?.toString().toUpperCase() || "";
  const themeColor1 = getComputedStyle(document.body).getPropertyValue("--bs-theme").trim();

  // ✅ Barsys Shaker Pro: Starts with BARSYS_S (per your Barsys_S* prefix)
  if (name.startsWith("BARSYS_S") || type.startsWith("BARSYS_S")) {
    imageSrc = "/assets/img/Shaker-Pro.jpg";

  // Barsys 360: Starts with BARSYS_3 or BARSYS_360
  } else if (
    name.startsWith("BARSYS3") || name.startsWith("BARSYS_3") || name.startsWith("BASYS_360") ||
    type.startsWith("BARSYS3") || type.startsWith("BARSYS_3") || type.startsWith("BASYS_360")
  ) {
    imageSrc = "/assets/img/barsys360.jpeg";

  // Barsys Coaster: Starts with BARSYS_C or BARSYS_CST
  } else if (
    name.startsWith("BARSYS_C") || name.startsWith("BASYS_C") ||
    type.startsWith("BARSYS_C") || type.startsWith("BASYS_C")
  ) {
    imageSrc = "/assets/img/BarsysCoaster.jpg";

  // Use device_photo if available
  } else if (device.device_photo) {
    imageSrc = device.device_photo;
  } else {
    imageSrc = "/assets/img/glassshimmer.png"; // fallback
  }

  // ✅ Better alt text (so Shaker Pro doesn't show as Barsys 360)
  const altText =
    (name.startsWith("BARSYS_S") || type.startsWith("BARSYS_S"))
      ? "Barsys Shaker Pro"
      : (device.device_type === "coaster" ? "Barsys Coaster" : "Barsys 360");

  return (
    <tr style={{ minHeight: 88 }}>
      {/* Rank */}
      <td style={{
        textAlign: "center",
        verticalAlign: "middle",
        fontWeight: "bold",
        color: themeColor1,
        width: 60,
      }}>
        {rank}
      </td>

      {/* Device Image */}
      <td style={{
        textAlign: "center",
        verticalAlign: "middle",
        width: 100,
      }}>
        <img
          src={imageSrc}
          alt={altText}
          style={{ width: 64, height: 64, borderRadius: 16, objectFit: "cover" }}
          onError={e => {
            e.target.onerror = null;
            e.target.src = "/assets/img/glassshimmer.png";
          }}
        />
      </td>

      {/* Device Name */}
      <td style={{
        textAlign: "left",
        verticalAlign: "middle",
        fontWeight: 500,
        borderRight: "none",
        minWidth: 200,
      }}>
        {device.device_name}
      </td>

      {/* Last Connected */}
      <td style={{
        verticalAlign: "middle",
        textAlign: "center",
        minWidth: 270,
        padding: 0,
        fontSize: 16,
        borderRight: "none",
        borderLeft: "none"
      }}>
        <span style={{
          display: "flex",
          alignItems: "center",
          height: 64, // make same as image
          gap: 8,
          justifyContent: "center",
        }}>
          <span
            style={{
              color: themeColor1,
              fontWeight: 500,
              letterSpacing: "0.5px",
              fontSize: 14,
              whiteSpace: "nowrap",
              minWidth: 110,
              display: "inline-block",
            }}
          >
            Last Connected:
          </span>
          <span
            style={{
              color: "#b6bdc7",
              fontWeight: 600,
              marginLeft: 0,
              fontSize: 12,
              whiteSpace: "nowrap",
              minWidth: 140,
              display: "inline-block",
            }}
          >
            {device.last_activity
              ? new Date(device.last_activity * 1000).toLocaleString("en-US", {
                  year: "numeric",
                  month: "2-digit",
                  day: "2-digit",
                  hour: "2-digit",
                  minute: "2-digit",
                })
              : "--"}
          </span>
        </span>
      </td>

      {/* View Button */}
      <td style={{
        verticalAlign: "middle",
        textAlign: "center",
        minWidth: 110,
        padding: 0,
        borderLeft: "none"
      }}>
        <button
          className="btn btn-theme"
          style={{
            minWidth: 60,
            fontSize: 14,
            padding: "6px 20px",
            margin: "auto",
            display: "block",
          }}
          onClick={() => onView(device)}
        >
          View
        </button>
      </td>
    </tr>
  );
}
